import React, { useState, useRef, useEffect } from 'react'; 
import './scss/puzztime.scss';
import Confetti from 'react-confetti';
import diccionario from './assets/palabras.json';
import HangmanStickmanSVG from './components/HangmanStickmanSVG';

import { initializeApp } from "firebase/app";
import { getAnalytics,logEvent } from "firebase/analytics";

import Rand, { PRNG } from 'rand-seed';
import { BrowserRouter, Routes, Route, Link, useLocation, useNavigate, useParams  } from 'react-router-dom';
import Header from './components/Header';
import Victoria from './components/Victoria';
import Derrota from './components/Derrota';
import TiemposCont from './components/TiemposCont';
import juegos from './assets/juegos.json';
import { getFirestore ,collection, getDocs ,addDoc, updateDoc, deleteDoc, doc ,getDoc, setDoc} from "firebase/firestore";
import ObtFraseFin from './Utilidades';
import AbajoJuegos from './components/AbajoJuegos';


// Tipos para TypeScript
type Letra = {
  letra: string;
  estado: number;
};

type LetraSolucion = {
  letra: string;
  encontrado: number;
};

function Ahorcado() {
 const params = useParams();
 var rand:Rand;

 const firebaseConfig = {
  apiKey: "AIzaSyCceVPpjBFbA_khqjXABlFtdex6wU6YWPM",
  authDomain: "everyday---deia.firebaseapp.com",
  projectId: "everyday---deia",
  storageBucket: "everyday---deia.firebasestorage.app",
  messagingSenderId: "789110585317",
  appId: "1:789110585317:web:5d01114092fe374edce10c",
  measurementId: "G-N0EC1VFRC5"
};

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  const db = getFirestore(app);

  const navigate = useNavigate();

  const [fechaAct,setFechaAct]=useState(new Date());
  const [fechaTexto,setFechaTexto]=useState("");
  const [palabra, setPalabra] = useState<string>('QUESO');
  const [tema, setTema] = useState<string>('COMIDA');
  const [letras, setLetras] = useState<LetraSolucion[]>([]);
  const [letrasTeclado, setLetrasTeclado] = useState<Letra[]>([]);
  const [intentos, setIntentos] = useState<number>(9);
  const [gameLost, setGameLost] = useState<boolean>(false);
  const [gameWon, setGameWon] = useState<boolean>(false);
  const [iniciado, setIniciado] = useState<boolean>(false);
  const [confettiVisible, setConfettiVisible] = useState<boolean>(false);
  const [secondsElapsed, setSecondsElapsed] = useState<number>(0);
  const [timerRunning, setTimerRunning] = useState<boolean>(false);
  const [juegoAct, setJuegoAct]=useState(juegos[0]);

  const wordBoxRef = useRef<HTMLDivElement>(null);

  const audioWon = new Audio('./sounds/won.mp3');
  const audioLose = new Audio('./sounds/lost.mp3');
  const audioOk = new Audio('./sounds/acierto.mp3');
  const audioWrong = new Audio('./sounds/error.mp3');

  const [fraseSeleccionada, setFraseSeleccionada]=useState(""); 
  const [medalla, setMedalla] = useState(-1);
  const [media, setMedia] = useState(-1);
  const [porcentajeSuperado, setPortentajeSuperado] = useState(-1);

  const today = new Date().toLocaleDateString('es-ES', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  }).toUpperCase();

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (timerRunning) {
      interval = setInterval(() => {
        setSecondsElapsed((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timerRunning]);

  if (!iniciado) IniciarPalabra();

  function IniciarPalabra() {
    const dayNames = ["Domingo", "Lunes", "Martes","Miércoles","Jueves","Viernes","Sabado"];
    let params = useParams();
    var today = new Date();
    //alert(today.toLocaleDateString('en-US'));
    //alert("Días "+params.dia);
    var numDias=parseInt(params.dia!);
    today.setDate(today.getDate() - numDias);
    //alert(today.toLocaleDateString('en-US'));
    rand=new Rand(today.toLocaleDateString('en-US'));

    if(numDias==0){
      setFechaTexto("Hoy, "+today.getDate());
    }
    else if(numDias==1){
      setFechaTexto("Ayer "+today.getDate());
    }else{
      setFechaTexto(dayNames[today.getDay()] + " "+today.getDate());
    }
    setFechaAct(today);

    let categoria = diccionario[RandomNumber(0, diccionario.length - 1)];
    let palabraAct = categoria.palabras[RandomNumber(0, categoria.palabras.length - 1)];
    while (palabraAct.includes(' ')) palabraAct = categoria.palabras[RandomNumber(0, categoria.palabras.length - 1)];
    palabraAct = palabraAct.toUpperCase();
    setPalabra(palabraAct);
    setTema(categoria.tema);

    const letrasTodas = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZ'.split('');
    const letrasTecladoState = letrasTodas.map(letra => ({ letra, estado: 0 }));
    setLetrasTeclado(letrasTecladoState);

    const letrasState = palabraAct.split('').map(letra => ({ letra, encontrado: 0 }));
    setLetras(letrasState);
    setSecondsElapsed(0);
    setTimerRunning(true);
    setIniciado(true);

    if(localStorage.getItem("medalla_ahorcado_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate())==null){
      //alert("sin jugar");
    }else{
      //alert("Ya jugado "+localStorage.getItem("medalla_parejas_"+today.getFullYear()+"-"+(today.getMonth()+1)+"-"+today.getDate()));
      
      setTimeout(function () {
              navigate("/dias/ahorcado");
      }, 50);
      
    }
  }

  function RandomNumber(min: number, max: number): number {
    return Math.floor(rand.next()* (max - min + 1)) + min;
  }

  function Reiniciar() {
    window.location.reload();
  }


  function ClickBack(){
  //navigate("/dias/ahorcado");
  AbrirLateral();
}

function AbrirLateral(){
    document.getElementById("lateral-juegos")!.style.left = "0px";
    document.getElementById("lateral-juegos")!.style.boxShadow = "4px 0 20px rgba(0,0,0,0.08)";
    document.getElementById("lateral-overlay")!.style.opacity = "1";
    document.getElementById("lateral-overlay")!.style.pointerEvents = "auto";
}


const getTimes = async (tiempo: number) => {
    const docRef = doc(db, "tiempos_ahorcado", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate())
    const docSnap = await getDoc(docRef)
    let porcentajeS=100;
    if (docSnap.exists()) {
       console.log("Document data:", docSnap.data())
       let data=docSnap.data();

       let media=0;
       let contSuperado=0;

       for(var i=0; i<data.tiempos.length; i++){
          media=media+data.tiempos[i];
          if(data.tiempos[i]>=tiempo){
            contSuperado++;
          }
       }
       let medallaAct=0;
       media=media/data.tiempos.length;
       porcentajeS=(contSuperado/data.tiempos.length)*100;
       if(porcentajeS>=90){
        medallaAct=3;
       }else if(porcentajeS>=70){
        medallaAct=2;
       }else if(porcentajeS>=50){
        medallaAct=1;
       }else{
        medallaAct=0;
       }
       setMedalla(medallaAct);
       localStorage.setItem("medalla_ahorcado_"+fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate(),""+medallaAct);

       setPortentajeSuperado(porcentajeS);
       setMedia(media);
       console.log("Media -> "+media+" portentaje -> "+porcentajeS+" contSuperado ->"+contSuperado);
       data.tiempos.push(tiempo);
       setDoc(doc(db, "tiempos_ahorcado", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()), data);


      //setUser(docSnap.data())
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
      const data = {
        tiempos:[tiempo]
      };
      porcentajeS=100;
      localStorage.setItem("medalla_ahorcado_"+fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate(),""+3);
      setDoc(doc(db, "tiempos_ahorcado", fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate()), data);
      setMedalla(3);
      setMedia(tiempo);
      setPortentajeSuperado(100);
    }
    setFraseSeleccionada(ObtFraseFin(porcentajeS));
  }



function Continuar(){
    //window.location.reload();
    navigate("/dias/ahorcado");
  }

  function handleClick(l: Letra): void {
    if (l.estado !== 0 || gameLost || gameWon) return;

    const newLetrasTeclado = [...letrasTeclado];
    const newLetras = [...letras];
    let letraEncontrada = false;

    for (let i = 0; i < newLetras.length; i++) {
      const normalized = newLetras[i].letra.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      if (normalized === l.letra) {
        newLetras[i].encontrado = 1;
        letraEncontrada = true;
      }
    }

    for (let i = 0; i < newLetrasTeclado.length; i++) {
      if (newLetrasTeclado[i].letra === l.letra) {
        newLetrasTeclado[i].estado = letraEncontrada ? 2 : 1;
      }
    }

    if (!letraEncontrada) {
      audioWrong.play();
      setIntentos(prev => prev - 1);
      const wordBox = document.querySelector('.word-box');
      if (wordBox) {
        wordBox.classList.add('shake');
        setTimeout(() => wordBox.classList.remove('shake'), 400);
      }
    } else {
      audioOk.play();
    }

    setLetras(newLetras);
    setLetrasTeclado(newLetrasTeclado);

    if (newLetras.every(l => l.encontrado === 1)) {
      getTimes(secondsElapsed);
      setConfettiVisible(true);
      setTimeout(() => {
        setGameWon(true);
      }, 2000);
      setTimerRunning(false);
      audioWon.play();
    }

    if (intentos === 1 && !letraEncontrada) {
      localStorage.setItem("medalla_ahorcado_"+fechaAct.getFullYear()+"-"+(fechaAct.getMonth()+1)+"-"+fechaAct.getDate(),"-1");
      setGameLost(true);
      setTimerRunning(false);
      audioLose.play();
      for (let i = 0; i < newLetras.length; i++) {
        if (newLetras[i].encontrado === 0) newLetras[i].encontrado = -1;
      }
      setLetras(newLetras);
    }
  }

  const formatClock = (totalSeconds: number): string => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };


  return (
    <div className="puzztime hangman">
     

      {/* --------------------- HEADER --------------------- */}

      <Header nombre={juegoAct.nombre} color={juegoAct.color} clicked={() => ClickBack()} ></Header>


      <div className="game-area">
       {/* --------------------- GAME META --------------------- */}

      <TiemposCont fechaTexto={fechaTexto} secondsElapsed={formatClock(secondsElapsed)}></TiemposCont>

    {/* --------------------- GAME CONTENT --------------------- */}

    <main className="game-content">
       <div className="svg-container">
            <HangmanStickmanSVG errors={9 - intentos} />
          </div>

          <div className="categoria">{tema}</div>

            <div className="word-box" ref={wordBoxRef}>
              {letras.map((l, i) => (
                <div
                  key={i}
                  className={`letter ${l.encontrado === 1 ? 'acertada' : ''}`}
                >
                  {l.encontrado === 1 ? l.letra : ''}
                </div>
              ))}
            </div>

            <div className="keyboard">
              {letrasTeclado.map((l, i) => (
                <div onClick={() => handleClick(l)}>
                  <button
                    key={i}
                    className={`key ${l.estado === 2 ? 'correct' : l.estado === 1 ? 'wrong' : ''}`}
                  >
                    {l.letra}
                  </button>
              </div>
              ))}
            </div>
       </main>

        {/* Mensaje de victoria */}
        {gameWon &&(
          <Victoria
            nombre={juegoAct.nombre}
            color={juegoAct.color}
            today={today}
            fraseSeleccionada={fraseSeleccionada}
            secondsElapsed={formatClock(secondsElapsed)}
            medalla={medalla}
            media={media}
            porcentajeSuperado={porcentajeSuperado}
            clickContinuar={Continuar}
            icono={juegoAct.icono}
            idJuego={1}
            ></Victoria>
          )}

        {/* Mensaje de derrota */}
        {gameLost && (
          <Derrota
            nombre={juegoAct.nombre}
            color={juegoAct.color}
            today={today}
            fraseSeleccionada={fraseSeleccionada}
            secondsElapsed={formatClock(secondsElapsed)}
            clickContinuar={Continuar}
            icono={juegoAct.icono}
            palabra={palabra}
            idJuego={1}
            ></Derrota>
        )}
      </div>

      {/* Confetti encima de todo */}
      {confettiVisible && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999, pointerEvents: 'none' }}>
          <Confetti
            width={window.innerWidth}
            height={window.innerHeight}
            numberOfPieces={200}
            gravity={0.05}
            recycle={false}
            initialVelocityY={15}
            colors={['#8CB3F3', '#CEA3FF', '#FA6F68', '#FBCB5F', '#A0C95D']}
            drawShape={ctx => {
              const w = 15, h = 8, r = 3;
              ctx.beginPath();
              ctx.moveTo(r, 0);
              ctx.arcTo(w, 0, w, h, r);
              ctx.arcTo(w, h, 0, h, r);
              ctx.arcTo(0, h, 0, 0, r);
              ctx.arcTo(0, 0, w, 0, r);
              ctx.closePath();
              ctx.fill();
            }}
          />
        </div>
      )}

        <AbajoJuegos idJuegoAct={1} diaActual={parseInt(params.dia!)}></AbajoJuegos>

    </div>
  );
}

export default Ahorcado;
